import React from 'react'
import { useIntl } from 'react-intl'
import {
  MenuItem,
  Tooltip
} from '@contrast-security-inc/design-system-popovers'
import { IconDelete } from '@contrast-security-inc/design-system-foundations'
import { IconButton } from '@contrast-security-inc/design-system-buttons'
import { Library } from './bulk-delete-modal'
import { RoleSwitch } from 'contrastBase/RoleSwitch'
import { Role } from '@contrast-security-inc/base-types'

const DisabledDeleteIcon = ({ message }: { message: string }) => {
  const intl = useIntl()

  return (
    <span>
      <Tooltip
        body={intl.formatMessage({
          id: 'title_vulnerabilities_insufficientDeletePermissions'
        })}
      >
        <IconButton aria-label={message} isDisabled Icon={IconDelete} />
      </Tooltip>
    </span>
  )
}

export const deleteBtnTestID = 'bulk-delete-libraries-btn'

export function BulkDeleteLibrariesAction({
  libraries,
  showDisabled,
  organizationRole,
  renderIcon = true,
  setShowDeleteModal
}: {
  libraries: Library[]
  showDisabled: boolean
  organizationRole: Role
  renderIcon?: boolean
  setShowDeleteModal: (isOpen: boolean) => void
}) {
  const { formatMessage } = useIntl()

  const message = formatMessage({
    id:
      libraries.length === 1
        ? 'action_deleteOneLibrary'
        : 'action_deleteMultipleLibraries'
  })

  return (
    <RoleSwitch
      role={organizationRole}
      requiredRole="EDIT"
      renderDenied={
        showDisabled
          ? () => <DisabledDeleteIcon message={message} />
          : undefined
      }
      renderAllowed={() => (
        <>
          {renderIcon ? (
            <Tooltip placement="top" body={message}>
              <IconButton
                Icon={IconDelete}
                aria-label="Delete"
                size="md"
                testId={deleteBtnTestID}
                onClick={() => setShowDeleteModal(true)}
              />
            </Tooltip>
          ) : (
            <div
              onClick={() => {
                setShowDeleteModal(true)
              }}
            >
              <MenuItem testId="library-summary-bulk-delete-libraries-menu-item">
                {formatMessage({ id: 'action_deleteOneLibrary' })}
              </MenuItem>
            </div>
          )}
        </>
      )}
    />
  )
}
